import type { IxcPaymentsV1IncomingWireKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PAYMENTS_INCOMING_WIRE_BASE_PATH = getResolvedPath('/clearing/finance/payment/incoming-wire');

export const getPaymentsIncomingWirePath: EntityPathBuilder<IxcPaymentsV1IncomingWireKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PAYMENTS_INCOMING_WIRE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.wireId) {
        return undefined;
      }

      return getResolvedPath(`${PAYMENTS_INCOMING_WIRE_BASE_PATH}/$wireId`, context.keys);
    }
  }
};

export function getPaymentsIncomingWireDetailPath(wireId: string | undefined) {
  if (!wireId) {
    return undefined;
  }

  return getPaymentsIncomingWirePath({ kind: 'detail', keys: { wireId } });
}
